import { render, staticRenderFns } from "./OurService.vue?vue&type=template&id=7543ede8"
import script from "./OurService.vue?vue&type=script&lang=js"
export * from "./OurService.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports